export default "__VITE_ASSET__2129d0ec__"